import { Logo } from "./Logo";

/** Minimal footer — wordmark, one-liner, year. Kept intentionally light. */
export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-[var(--separator)] py-10">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-4 sm:flex-row sm:justify-between sm:px-6">
        <div className="flex items-center gap-3">
          <Logo />
        </div>
        <p className="text-sm text-[var(--muted)]">© {year} · Ciam</p>
      </div>
    </footer>
  );
}
